import _defineProperty from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { display, addEventListener, buildEndpointHost } from '@datadog/browser-core';
var REMOTE_CONFIGURATION_VERSION = 'v1';
var STATIC_OPTIONS = ['applicationId', 'service', 'env', 'version', 'sessionSampleRate', 'sessionReplaySampleRate', 'defaultPrivacyLevel', 'enablePrivacyForActionName'];
export function fetchAndApplyRemoteConfiguration(initConfiguration, callback) {
  fetchRemoteConfiguration(initConfiguration, function (remoteInitConfiguration) {
    callback(applyRemoteConfiguration(initConfiguration, remoteInitConfiguration));
  });
}
export function applyRemoteConfiguration(initConfiguration, rumRemoteConfiguration) {
  // intents:
  // - explicitly set each supported field to limit risk in case an attacker can create configurations
  // - check the existence in the remote config to avoid clearing a provided init field
  var appliedConfiguration = _objectSpread({}, initConfiguration);
  STATIC_OPTIONS.forEach(function (option) {
    if (option in rumRemoteConfiguration) {
      appliedConfiguration[option] = rumRemoteConfiguration[option];
    }
  });
  return appliedConfiguration;
}
export function fetchRemoteConfiguration(configuration, callback) {
  var xhr = new XMLHttpRequest();
  addEventListener(configuration, xhr, 'load', function () {
    if (xhr.status === 200) {
      var remoteConfiguration = JSON.parse(xhr.responseText);
      if (remoteConfiguration.rum) {
        callback(remoteConfiguration.rum);
      } else {
        display.error('No remote configuration for RUM.');
      }
    } else {
      displayRemoteConfigurationFetchingError();
    }
  });
  addEventListener(configuration, xhr, 'error', function () {
    displayRemoteConfigurationFetchingError();
  });
  xhr.open('GET', buildEndpoint(configuration));
  xhr.send();
}
export function buildEndpoint(configuration) {
  return "https://sdk-configuration.".concat(buildEndpointHost('rum', configuration), "/").concat(REMOTE_CONFIGURATION_VERSION, "/").concat(encodeURIComponent(configuration.remoteConfigurationId), ".json");
}
function displayRemoteConfigurationFetchingError() {
  display.error('Error fetching the remote configuration.');
}